import { memo } from '@morphic-ts/common/es6/utils';
import { either as E } from 'fp-ts';
import { pipe } from 'fp-ts/es6/function';
import { failure, success, Type } from 'io-ts';
import { iotsApplyConfig } from '../config';
import { IOTSType, IoTsURI } from '../hkt';
const coerce = (e) => e;
/**
 *  @since 0.0.1
 */
export const ioTsNewtypeInterpreter = memo(() => ({
    _F: IoTsURI,
    newtype: () => (a, config) => env => pipe(a(env).type, type => new IOTSType(iotsApplyConfig(config)(coerce(type), env, { type }))),
    newtypeIso: (iso, a, name, config) => env => pipe(a(env).type, type => {
        const is = (v) => type.is(v);
        return new IOTSType(iotsApplyConfig(config)(new Type(name, is, (i, c) => pipe(type.validate(i, c), E.map(iso.get)), v => type.encode(iso.reverseGet(v))), env, { type }));
    }),
    newtypePrism: (prism, a, name, config) => env => pipe(a(env).type, type => {
        const is = (v) => type.is(v);
        return new IOTSType(iotsApplyConfig(config)(new Type(name, is, (i, c) => pipe(type.validate(i, c), E.chain(v => {
            const x = prism.getOption(v);
            return x._tag === 'None'
                ? failure(i, c, `newtype doesn't satisfy prism conditions`)
                : success(x.value);
        })), v => type.encode(prism.reverseGet(v))), env, { type }));
    })
}));
